
// Simple feature flags management
const FEATURE_FLAGS = {
  CONTACT_BOOKING: true,
  EMAIL_BOOKING: true,  // Changed from false to true to show both features
  MEETING_DURATION: true,
  VOICE_RECORDING: false, // voice recording feature flag
  // Add more features here
};

export const isFeatureEnabled = (featureName: keyof typeof FEATURE_FLAGS): boolean => {
  return FEATURE_FLAGS[featureName] ?? false;
};
